import { BehaviorSubject, of as observableOf, Observable, Subject, takeUntil } from 'rxjs';
import { Configuracoes } from './../../../models/configuracoes.model';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TIMEZONE_KEY } from './../../../const';
import { TimeZone } from './../../../models/time-zone.model';
import { AbConfiguracoes } from 'app/abstract/full-pages/configuracoes/configuracoes.abstract';
import { CodigoPreCadastroAction } from 'enums/codigo-pre-cadastro-action.enum';
import { CodigoPreCadastroResponse } from 'app/models/codigo-pre-cadastro-response.model';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracoesService extends AbConfiguracoes implements OnDestroy {
  KEY_CONFIGURACOES = 'configuracaoConta';
  private readonly configuracoesSubject = new BehaviorSubject<Configuracoes | null>(null);
  readonly configuracoes$ = this.configuracoesSubject.asObservable();
  private readonly destroy$ = new Subject();

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfiguracoes(): Observable<any> {
    const configuracoes: Configuracoes = JSON.parse(
      sessionStorage.getItem(this.KEY_CONFIGURACOES)
    );

    if (configuracoes) {
      this.getZoneId(configuracoes.zoneId);
      this.configuracoesSubject.next(configuracoes);
      return observableOf(configuracoes);
    }

    const ret = this.get(`public/configuracoes/1`);
    this.salvarConfiguracaoNoStorage(ret);
    return ret;
  }

  public getReloadConfiguracoes(): Observable<any> {
    const ret = this.get(`public/configuracoes/1`);
    this.salvarConfiguracaoNoStorage(ret);
    return ret;
  }

  public salvarConfiguracaoNoStorage(cfg: Observable<any>) {
    cfg.pipe(takeUntil(this.destroy$)).subscribe((ret) => {
      if (ret) {
        sessionStorage.setItem(this.KEY_CONFIGURACOES, JSON.stringify(ret));
        this.configuracoesSubject.next(ret);
        this.getZoneId(ret.zoneId);
      }
    });
  }

  public getZoneId(idTimezone) {
    if (idTimezone != null) {
      this.getOneTimeZone(idTimezone)
        .pipe(takeUntil(this.destroy$))
        .subscribe((time: TimeZone) => {
          this.salvarTimeZoneNoStorage(time.zoneId);
        });
    }
  }

  public salvarTimeZoneNoStorage(tz: string) {
    sessionStorage.setItem(TIMEZONE_KEY, JSON.stringify(tz));
  }

  public saveConfiguracoes(configuracoes: Configuracoes): Observable<any> {
    const ret = this.save(`configuracoes/`, configuracoes);

    this.salvarConfiguracaoNoStorage(ret);

    return ret;
  }

  public getTimeZones(config: string): Observable<any> {
    return this.get(`timezones/filter/${config}`);
  }

  public getOneTimeZone(id: number): Observable<any> {
    return this.get(`public/timezones/${id}`);
  }

  public putAtivarNovoModelo(): Observable<any> {
    return this.http.put(this.url + `api/v1/configuracoes/novo-fluxo-app`, {});
  }

  public putAcaoCodigoCadastro(acao: CodigoPreCadastroAction): Observable<CodigoPreCadastroResponse> {
    const payload = { acao };
    return this.http.put<CodigoPreCadastroResponse>(this.url + 'api/v1/contas/codigo-pre-cadastro', payload);
  }

  public getStatusCodigoPreCadastro(integradorUuidOrId: string): Observable<{ codigoPreCadastroAtivo: boolean }> {
    return this.get(
      `public/admin/v1/config-integrador/integrador/${integradorUuidOrId}/codigo-pre-cadastro/status`
    ) as Observable<{ codigoPreCadastroAtivo: boolean }>;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
